import { Result } from 'antd';
import React, { Suspense } from 'react';
import Seo from '../../seo/Seo';
import { Link, Navigate, Route, Routes } from 'react-router';
import { getRoutes } from '../app/appRoutes';
import Layout from '../app/layout/Layout';
import DocsScreen from '../app/docsScreen/DocsScreen';
import LandingPage from '../app/landingScreen/LandingPage';

const HydrateFallback = () => {
  return (
    <div>
      <div className='flex items-center justify-center h-screen'>
        <div className='flex flex-col items-center'>
          <div className='text-2xl font-bold text-gray-800'>Loading...</div>
        </div>
      </div>
    </div>
  );
};

const ErrorBoundary = ({ error }) => {
  return (
    <div>
      <div className='flex items-center justify-center h-screen'>
        <div className='flex flex-col items-center'>
          <div className='text-2xl font-bold text-gray-800'>Error</div>
          <div className='text-gray-800'>{error.message}</div>
        </div>
      </div>
    </div>
  );
};

function Navigation() {
  const filteredRoutes = getRoutes(); // Get routes user has access to

  return (
    <>
    <Seo />
    <Suspense fallback={<HydrateFallback />}>
    <Routes>
      {/* Routes without layout (no global header) */}
      <Route path='/docs' element={<DocsScreen />} />
      <Route path='/' element={<LandingPage />} />
      
      {/* All other routes with layout */}
      <Route
        Component={Layout}
        fallback={<HydrateFallback />}
        errorBoundary={<ErrorBoundary />}
        hydrateFallbackElement={<HydrateFallback />}
      >
        {filteredRoutes.filter(route => route.path !== '/docs' && route.path !== '/').map((route) => (
          <Route key={route.key} path={route.path} element={route.component} />
        ))}
        <Route
          path='/404'
          element={
            <Result
              status='404'
              title='404'
              subTitle='Sorry, the page you visited does not exist.'
              extra={<Link to='/'>Back Home</Link>}
            />
          }
        />
        <Route path='*' element={<Navigate replace to='/404' />} />
      </Route>
    </Routes>
    </Suspense>
    </>
  );
}

export default Navigation;
